import type { RoleConfig } from '../types.js';

export const escort: RoleConfig = {
  id: 'escort',
  faction: 'town',
  title: { ru: 'Эскорт', uk: 'Ескорт' },
  latin: 'ESCORT',
  number: '33',
  accent: '#ff9bbd',
  ability: {
    ru: 'Ночью отвлекает игрока — его действие в эту ночь не сработает.',
    uk: 'Вночі відволікає гравця — його дія цієї ночі не спрацює.',
  },
  abilities: [
    { key: 'distract', phase: 'night', cadence: 'every-night', canSelfTarget: false },
  ],
  victory: { type: 'town' },
};
